import { render, staticRenderFns } from "./activePlayers.vue?vue&type=template&id=45d1396d&scoped=true"
import script from "./activePlayers.vue?vue&type=script&lang=js"
export * from "./activePlayers.vue?vue&type=script&lang=js"
import style0 from "./activePlayers.vue?vue&type=style&index=0&id=45d1396d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1396d",
  null
  
)

export default component.exports